export default [
  {
    title: 'Links',
    icon: 'CodeIcon',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Manage',
        route: 'shortcode-manage',
      },
      {
        title: 'Reporting',
        route: 'shortcode-usage-report',
      }
    ],
  },
]
